import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from '@raffle/ui';
import { AuthProvider } from './providers/AuthProvider';
import { AdminLayout } from './components/layout/AdminLayout';

// Pages
import { DashboardPage } from './pages/DashboardPage';
import { PropertiesPage } from './pages/PropertiesPage';
import { PropertyEditPage } from './pages/PropertyEditPage';
import { TicketsPage } from './pages/TicketsPage';
import { DrawsPage } from './pages/DrawsPage';
import { UsersPage } from './pages/UsersPage';
import { SupportPage } from './pages/SupportPage';
import { SettingsPage } from './pages/SettingsPage';
import { LoginPage } from './pages/auth/LoginPage';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <ToastProvider>
        <Routes>
          {/* Auth Routes */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Admin Routes */}
          <Route path="/" element={<AdminLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="properties" element={<PropertiesPage />} />
            <Route path="properties/new" element={<PropertyEditPage />} />
            <Route path="properties/:id/edit" element={<PropertyEditPage />} />
            <Route path="tickets" element={<TicketsPage />} />
            <Route path="draws" element={<DrawsPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="support" element={<SupportPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ToastProvider>
    </AuthProvider>
  );
};

export default App;
